export default "__VITE_ASSET__6f095820__"